import { useSelector } from 'react-redux';
import useHousingStockMatch from './useHousingStockMatch';
import useRequestsHouse from '../queries/useRequestsHouse';
import { chessViewMode } from '../constants/chessViewMode';

const useRequestByHouse = () => {
  const { params } = useHousingStockMatch();
  const { pageId } = params || {};

  const { chessViewColorMode, monitoringStage, dateExcess } = useSelector(
    (state) => state.housingStockStore
  );

  const { data: requests = [] } = useRequestsHouse(
    {
      addressStageRequest: monitoringStage,
      houseId: pageId,
      ...(!!dateExcess ? { targetDate: dateExcess } : {}),
    },
    {
      enabled: !!(
        !!monitoringStage &&
        chessViewColorMode === chessViewMode.applicationMonitoring
      ),
      select: (data) => data?.requests,
    }
  );

  return { requests };
};

export default useRequestByHouse;
